<template>
  <v-card class="mx-auto h-100" :max-height="sliderHeight" variant="outlined">
    <v-toolbar color="primary" density="default">
      <v-toolbar-title class="text-white">
        {{ $t("strings.chart-type") }}
        <div class="text-caption">{{ $t("strings.chart-type-subtitle") }}</div>
      </v-toolbar-title>
    </v-toolbar>
    <v-sheet :max-height="slideGroupHeight">
      <v-slide-group
        v-model="model"
        selected-class="elevation-6"
        mandatory
        show-arrows
        direction="vertical"
        next-icon="mdi-chevron-down-circle-outline"
        prev-icon="mdi-chevron-up-circle-outline"
        color="secondary"
      >
        <v-slide-group-item
          v-for="item in chartTypes"
          :key="item.id || item.type"
          v-slot="{ toggle, selectedClass }"
        >
          <v-sheet
            class="my-2 mx-2 w-auto"
            height="150"
            variant="flat"
            rounded="lg"
            @click="selectChart(item, toggle)"
          >
            <div class="d-flex fill-height align-center justify-center">
              <v-card
                width="95%"
                height="150"
                variant="elevated"
                :ripple="false"
                :class="[selectedClass]"
              >
                <v-card-title class="text-center text-capitalize">
                  {{ getChartLabel(item) }}
                </v-card-title>
                <v-card-text class="px-0 pb-1">
                  <div style="height: 100px">
                    <slider-thumbnail
                      class="chart-preview"
                      :type="item.type"
                      :data="item.data"
                      :labels="item.labels"
                      :horizontal="item.horizontal"
                    />
                  </div>
                </v-card-text>
              </v-card>
            </div>
          </v-sheet>
        </v-slide-group-item>
      </v-slide-group>
    </v-sheet>
  </v-card>
</template>

<script setup>
import { computed, ref, onMounted, watch } from "vue";
import SliderThumbnail from "./SliderThumbnail.vue";

const model = ref(0);
const emit = defineEmits(["selectedChart"]);
const props = defineProps({
  sliderHeight: String,
  chartTypes: Array,
  typeSelected: String,
  isQualitative: Boolean,
});
const slideGroupHeight = computed(() => {
  return `calc(${props.sliderHeight} - 64px)`;
});

function selectChart(chartType, toggle) {
  toggle();
  emit("selectedChart", chartType);
}

function getChartLabel(item) {
  if (item.id === "bar-horizontal") {
    return "bar (h)";
  } else if (item.id === "bar-vertical") {
    return "bar (v)";
  } else if (item.type === "area") {
    return "area";
  } else if (item.type === "polarArea") {
    return "polar";
  }
  return item.type;
}

// Function to calculate model value based on typeSelected
function calculateModel() {
  const chartIndex = props.chartTypes.findIndex(
    (item) => (item.id || item.type) === props.typeSelected,
  );
  model.value = chartIndex !== -1 ? chartIndex : 0;
}

// Watch for changes in typeSelected and update model accordingly
watch(
  () => props.typeSelected,
  () => {
    calculateModel();
  },
);

// Retrieve initial model value from selected chart type
onMounted(() => {
  calculateModel();
});
</script>
